module.exports = __webpack_public_path__ + "static/patent_arts-c55d4a9e6d73dcdcc8af5abe0bb82d18.png";